import { combineReducers } from 'redux';
import clientes from '@ducks/clientes';
import conectoresBloqueios from '@ducks/conectoresBloqueios';
import conectoresComandos from '@ducks/conectoresComandos';
import conectoresConexoes from '@ducks/conectoresConexoes';
import conectoresConfiguracoes from '@ducks/conectoresConfiguracoes';
import conectoresConfiguracoesInformacoes from '@ducks/conectoresConfiguracoesInformacoes';
import conectoresDuplicacao from '@ducks/conectoresDuplicacao';
import conectoresFolgas from '@ducks/conectoresFolgas';
import conectoresFontesDados from '@ducks/conectoresFontesDados';
import conectoresHeaders from '@ducks/conectoresHeaders';
import conectoresHorarioFuncionamento from '@ducks/conectoresHorarioFuncionamento';
import conectoresLogs from '@ducks/conectoresLogs';
import conectoresNotificacao from '@ducks/conectoresNotificacao';
import conectoresRequisicoes from '@ducks/conectoresRequisicoes';
import conectoresTarefas from '@ducks/conectoresTarefas';
import conectoresTemplatesGrupos from '@ducks/conectoresTemplatesGrupos';
import conectoresTemplates from '@ducks/conectoresTemplates';
import conectoresVersoes from '@ducks/conectoresVersoes';
import indicadoresVariaveisAmbiente from '@ducks/indicadoresVariaveisAmbiente';
import indicadoresExclusaoDados from '@ducks/indicadoresExclusaoDados';
import logsTempos from '@ducks/logsTempos';
import login from '@ducks/login';
import notificacoes from '@ducks/notificacoes';
import theme from '@ducks/app';

const Reducers = combineReducers({
  clientes,
  conectoresBloqueios,
  conectoresComandos,
  conectoresConexoes,
  conectoresConfiguracoes,
  conectoresConfiguracoesInformacoes,
  conectoresDuplicacao,
  conectoresFolgas,
  conectoresFontesDados,
  conectoresHeaders,
  conectoresHorarioFuncionamento,
  conectoresLogs,
  conectoresNotificacao,
  conectoresRequisicoes,
  conectoresTarefas,
  conectoresTemplatesGrupos,
  conectoresTemplates,
  conectoresVersoes,
  indicadoresVariaveisAmbiente,
  indicadoresExclusaoDados,
  login,
  notificacoes,
  logsTempos,
  theme,
});

export default Reducers;
